import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import PageConPc from '@/components/PowerOcean/Collection';
import PageConH5 from '@/componentsH5/PowerOcean/Collection';
import SEOlinksA from '@/components/SEOlinksA';

export default function Page({ SEO }: any) {
    const { isMobile, useRouter, useLang, useEffect } = useGlobal();
    const router = useRouter();
    const { t } = useLang('home');
    const { locale } = router;
    const PageCon = isMobile ? PageConH5 : PageConPc;
    const theme = '';

    useEffect(() => {
        if (!['de'].includes(locale)) {
            router.push('/404');
        }
    }, [locale, router]);

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={['de']} locale={locale} pathname={'home'} />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                <PageCon />
            </PageLayout>
        </>
    );
}
